<div [class.dark]="darkMode" class="p-4 bg-gray-100 dark:bg-gray-800">
    <ui-label [tag]="ELabelType.SECTION_TITLE" [type]="EAlert.DARK">{{ title }}</ui-label>

    <div class="mt-6 p-6 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md transition-all relative"
        (dragover)="dragOver($event)" (drop)="handleDrop($event)" [ngClass]="{
        'bg-gray-50 dark:bg-gray-700': files.length === 0,
        'bg-gray-100 dark:bg-gray-800': files.length > 0,
        'border-blue-400': isDragOver || isHovering,
        'hover:border-blue-500': !isDragOver && isHovering
      }" (mouseenter)="isHovering = true" (mouseleave)="isHovering = false">

        <div class="flex justify-center mb-4">
            <ui-icon [icon]="EIcon.Upload" [size]="EComponentSize.Large" [color]="EAlert.DARK"></ui-icon>
        </div>

        <div class="flex justify-center flex-col items-center text-center">
            <ui-label [tag]="ELabelType.PARAGRAPH" [type]="EAlert.DARK">Arraste e solte suas imagens aqui ou clique para
                selecionar</ui-label>
            <input type="file" multiple accept="image/*" class="hidden" (change)="handleFileChange($event)"
                id="fileInput" />
            <br>
            <ui-button [text]="'Selecionar Imagens'" (action)="triggerFileInput()" [type]="EAlert.DARK"
                [size]="EComponentSize.Small"></ui-button>
        </div>

        <div *ngIf="files.length" class="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div *ngFor="let file of files; let i = index"
                class="relative group overflow-hidden rounded-md shadow-md transition-all">
                <img [src]="file.preview"
                    class="w-full h-[400px] object-cover transition-all duration-300 transform group-hover:scale-105"
                    alt="Preview" />
                <button (click)="removeImage(i)"
                    class="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ui-icon [icon]="EIcon.Close" [size]="EComponentSize.Medium" [color]="EAlert.LIGHT"></ui-icon>
                </button>
            </div>
        </div>

    </div>

    <div class="flex justify-end mt-6">
        <ui-button *ngIf="files.length > 0" [text]="'Confirmar Imagens'" (action)="confirmImages()" [type]="EAlert.INFO"
            [size]="EComponentSize.Medium"></ui-button>
    </div>
</div>